module.exports = {"430527100":"长铺镇","430527101":"武阳镇","430527102":"李熙桥镇","430527103":"红岩镇","430527104":"唐家坊镇","430527105":"金屋塘镇","430527106":"瓦屋塘镇","430527107":"黄土矿镇","430527200":"东山侗族乡","430527201":"鹅公岭侗族苗族乡","430527203":"寨市苗族侗族乡","430527204":"乐安铺苗族侗族乡","430527206":"关峡苗族乡","430527207":"长铺子苗族侗族乡","430527210":"麻塘苗族瑶族乡","430527212":"河口苗族乡","430527217":"水口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430527.json
// module id = 1856
// module chunks = 0